import React, { useState } from 'react';
import { Button } from '../../../components/base/Button';

export const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d44s2d70vhksjg8rfmvg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          service: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-12 md:py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">お問い合わせ</h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            法的手続きでお困りの際は、お気軽にご相談ください。
            初回相談は30分まで無料で承っております。
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 max-w-6xl mx-auto">
          <div>
            <div className="bg-white rounded-lg shadow-lg p-5 md:p-8">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6">事務所情報</h3>
              
              <div className="space-y-4 md:space-y-6">
                <div className="flex items-start">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                    <i className="ri-map-pin-line text-xl md:text-2xl text-blue-600"></i>
                  </div>
                  <div className="min-w-0">
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm md:text-base">所在地</h4>
                    <p className="text-gray-600 text-sm md:text-base">〒700-0000<br />岡山市北区○○町1-2-3</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                    <i className="ri-phone-line text-xl md:text-2xl text-blue-600"></i>
                  </div>
                  <div className="min-w-0">
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm md:text-base">電話番号</h4>
                    <p className="text-gray-600 text-sm md:text-base">TEL: 086-012-3456<br />FAX: 086-012-3457</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-3 md:mr-4 flex-shrink-0">
                    <i className="ri-time-line text-xl md:text-2xl text-blue-600"></i>
                  </div>
                  <div className="min-w-0">
                    <h4 className="font-semibold text-gray-900 mb-1 text-sm md:text-base">営業時間</h4>
                    <p className="text-gray-600 text-sm md:text-base">9:00 〜 18:00<br />定休日: 日曜日・祝日</p>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-gray-200">
                <Button href="tel:086-012-3456" variant="primary" className="w-full mb-3 md:mb-4 text-sm md:text-base">
                  <i className="ri-phone-line mr-2"></i>
                  今すぐお電話
                </Button>
                <p className="text-xs md:text-sm text-gray-600 text-center">
                  お急ぎの場合は、お電話でのご相談をおすすめします
                </p>
              </div>
            </div>
          </div>
          
          <div>
            <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-lg p-5 md:p-8" data-readdy-form id="contact-form">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 md:mb-6">お問い合わせフォーム</h3>
              
              {submitStatus === 'success' && (
                <div className="mb-4 md:mb-6 p-3 md:p-4 bg-green-100 border border-green-400 text-green-700 rounded text-sm md:text-base">
                  お問い合わせありがとうございます。担当者より3営業日以内にご連絡いたします。
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="mb-4 md:mb-6 p-3 md:p-4 bg-red-100 border border-red-400 text-red-700 rounded text-sm md:text-base">
                  送信に失敗しました。お手数ですが、お電話でお問い合わせください。
                </div>
              )}
              
              <div className="space-y-4 md:space-y-6">
                <div>
                  <label htmlFor="name" className="block text-xs md:text-sm font-medium text-gray-700 mb-2">
                    お名前 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm md:text-base"
                    placeholder="山田 太郎"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-xs md:text-sm font-medium text-gray-700 mb-2">
                    メールアドレス <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm md:text-base"
                    placeholder="example@email.com"
                  />
                </div>
                
                <div>
                  <label htmlFor="phone" className="block text-xs md:text-sm font-medium text-gray-700 mb-2">
                    電話番号
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm md:text-base"
                    placeholder="086-012-3456"
                  />
                </div>
                
                <div>
                  <label htmlFor="service" className="block text-xs md:text-sm font-medium text-gray-700 mb-2">
                    ご相談内容 <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <select
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                      required
                      className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm md:text-base pr-8 appearance-none"
                    >
                      <option value="">選択してください</option>
                      <option value="不動産登記">不動産登記</option>
                      <option value="商業登記">商業登記</option>
                      <option value="相続手続き">相続手続き</option>
                      <option value="債務整理">債務整理</option>
                      <option value="成年後見">成年後見</option>
                      <option value="その他">その他</option>
                    </select>
                    <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                  </div>
                </div>
                
                <div>
                  <label htmlFor="message" className="block text-xs md:text-sm font-medium text-gray-700 mb-2">
                    詳細・ご質問 <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-3 md:px-4 py-2 md:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm md:text-base resize-vertical"
                    placeholder="ご相談内容の詳細をお聞かせください（500文字以内）"
                  />
                  <p className="text-xs text-gray-500 mt-1">{formData.message.length}/500文字</p>
                </div>
                
                <Button 
                  type="submit" 
                  variant="primary" 
                  className="w-full text-sm md:text-base"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? '送信中...' : 'お問い合わせを送信'}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};
